import { createContext, useContext, useEffect, useState } from "react";
import client from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        const raw = localStorage.getItem("fp_user");
        return raw ? JSON.parse(raw) : null;
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("fp_token");
        if (!token) { setLoading(false); return; }
        client.get("/auth/me")
            .then((r) => { setUser(r.data); localStorage.setItem("fp_user", JSON.stringify(r.data)); })
            .catch(() => { localStorage.removeItem("fp_token"); localStorage.removeItem("fp_user"); setUser(null); })
            .finally(() => setLoading(false));
    }, []);

    const login = async (email, password) => {
        const r = await client.post("/auth/login", { email, password });
        localStorage.setItem("fp_token", r.data.token);
        localStorage.setItem("fp_user", JSON.stringify(r.data.user));
        setUser(r.data.user);
        return r.data.user;
    };

    const logout = () => {
        localStorage.removeItem("fp_token");
        localStorage.removeItem("fp_user");
        setUser(null);
        window.location.href = "/login";
    };

    return <AuthCtx.Provider value={{ user, loading, login, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
